module.exports = __webpack_public_path__ + "img/group.bf753d81.png";